import { useRef, useEffect, useState } from "react";
import { Button } from "./ui/button";
import { Eraser, Check } from "lucide-react";

export function SignaturePad({ onConfirm, confirmLabel = "Unterschrift übernehmen" }) {
  const canvasRef = useRef(null);
  const drawing = useRef(false);
  const [empty, setEmpty] = useState(true);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ratio = window.devicePixelRatio || 1;
    const rect = canvas.getBoundingClientRect();
    canvas.width = rect.width * ratio;
    canvas.height = rect.height * ratio;
    const ctx = canvas.getContext("2d");
    ctx.scale(ratio, ratio);
    ctx.lineWidth = 2.2;
    ctx.lineCap = "round";
    ctx.strokeStyle = "#18181B";
  }, []);

  const pos = (e) => {
    const rect = canvasRef.current.getBoundingClientRect();
    const p = e.touches ? e.touches[0] : e;
    return { x: p.clientX - rect.left, y: p.clientY - rect.top };
  };

  const start = (e) => {
    drawing.current = true;
    const ctx = canvasRef.current.getContext("2d");
    const { x, y } = pos(e);
    ctx.beginPath();
    ctx.moveTo(x, y);
    e.preventDefault();
  };
  const move = (e) => {
    if (!drawing.current) return;
    const ctx = canvasRef.current.getContext("2d");
    const { x, y } = pos(e);
    ctx.lineTo(x, y);
    ctx.stroke();
    setEmpty(false);
    e.preventDefault();
  };
  const end = () => { drawing.current = false; };

  const clear = () => {
    const canvas = canvasRef.current;
    canvas.getContext("2d").clearRect(0, 0, canvas.width, canvas.height);
    setEmpty(true);
  };

  const confirm = () => {
    onConfirm(canvasRef.current.toDataURL("image/png"));
  };

  return (
    <div className="space-y-3" data-testid="signature-pad">
      <canvas
        ref={canvasRef}
        data-testid="signature-canvas"
        className="w-full h-44 border-2 border-dashed border-zinc-300 rounded-lg bg-zinc-50/50 hover:bg-zinc-50 touch-none cursor-crosshair transition-colors"
        onMouseDown={start} onMouseMove={move} onMouseUp={end} onMouseLeave={end}
        onTouchStart={start} onTouchMove={move} onTouchEnd={end}
      />
      <div className="flex gap-2 justify-end">
        <Button type="button" variant="outline" size="sm" onClick={clear} data-testid="signature-clear-button">
          <Eraser className="w-4 h-4 mr-1" /> Löschen
        </Button>
        <Button type="button" size="sm" onClick={confirm} disabled={empty} data-testid="signature-confirm-button"
          className="bg-zinc-900 hover:bg-zinc-800 text-white">
          <Check className="w-4 h-4 mr-1" /> {confirmLabel}
        </Button>
      </div>
    </div>
  );
}
